import React from 'react';

interface props {
  url: string;
}

export const DownloadableThumbnail = ({ url }: props) => {
  return (
    <a
      href={url}
      target="blank"
      download
      className="w-full aspect-square overflow-hidden rounded-lg bg-gray-100"
    >
      <img src={url} alt="" className="w-full h-full object-cover" />
    </a>
  );
};

export default DownloadableThumbnail;
